import React from "react";
import { Card, Form } from "react-bootstrap";
import DatePicker from "react-datepicker";
import "./SLMHistoryPanel.css";

export default function SLMHistoryPanel({ state, createId = (...segments) => ["slm-history", ...segments].join("-") }) {
  return (
    <Card className="mb-2 slm-history-panel">
      <Card.Header>History</Card.Header>
      <Card.Body>
        <div className="slm-history-container">
          <div className="slm-history-column">
            <div className="slm-history-field">
              <label id={createId("field", "created-by", "label")} className="slm-history-field-label">
                Created By
              </label>
              <Form.Control id={createId("field", "created-by", "input")} size="sm" className="slm-history-compact-input" disabled readOnly value={state.created_by} as="input" type="text" />
            </div>

            <div className="slm-history-field">
              <label id={createId("field", "created-date", "label")} className="slm-history-field-label">
                Created Date
              </label>
              <DatePicker
                id={createId("field", "created-date", "input")}
                selected={state.created_date !== null ? new Date(state.created_date) : null}
                dateFormat="dd/MM/yyyy"
                className="form-control form-control-sm slm-history-date-input slm-history-compact-input"
                disabled
                readOnly
              />
            </div>
          </div>

          <div className="slm-history-column">
            <div className="slm-history-field">
              <label id={createId("field", "last-edited-by", "label")} className="slm-history-field-label">
                Last Edited By
              </label>
              <Form.Control id={createId("field", "last-edited-by", "input")} size="sm" className="slm-history-compact-input" disabled readOnly value={state.last_edited_by} as="input" type="text" />
            </div>

            <div className="slm-history-field">
              <label id={createId("field", "last-edited-date", "label")} className="slm-history-field-label">
                Last Edited Date
              </label>
              <DatePicker
                id={createId("field", "last-edited-date", "input")}
                selected={state.last_edited_date !== null ? new Date(state.last_edited_date) : null}
                dateFormat="dd/MM/yyyy"
                className="form-control form-control-sm slm-history-date-input slm-history-compact-input"
                disabled
                readOnly
              />
            </div>
          </div>
        </div>
      </Card.Body>
    </Card>
  );
}